import { useId } from 'react';
import { useMapPreference } from '../map-preference';

export function MapPreferenceControl() {
  const { alwaysLoad, setAlwaysLoad } = useMapPreference();
  const descriptionId = useId();
  return (
    <div className="map-preference">
      <label>
        <input
          type="checkbox"
          checked={alwaysLoad}
          onChange={(event) => setAlwaysLoad(event.target.checked)}
          aria-describedby={descriptionId}
        />{' '}
        Always load maps on this browser
      </label>
      <small id={descriptionId}>
        Google receives your IP address and the location shown, and may use its own cookies. Turn
        this off to load maps only when you choose Show map.
      </small>
    </div>
  );
}
